/** Marca regiões onde gestos não devem acionar pull-to-refresh (sheets, modais). */
export const PULL_TO_REFRESH_IGNORE_ATTR = "data-ptr-ignore";

/** Atributo no `<html>` enquanto overlay bloqueia PTR globalmente (separado do ignore). */
const PULL_TO_REFRESH_LOCK_ATTR = "data-ptr-locked";

const PULL_TO_REFRESH_IGNORE_SELECTOR = `[${PULL_TO_REFRESH_IGNORE_ATTR}]`;

let lockCount = 0;

/** Bloqueia pull-to-refresh enquanto overlay/sheet/modal estiver aberto. */
export function acquirePullToRefreshLock(): () => void {
  if (typeof document === "undefined") {
    return () => {};
  }
  if (lockCount === 0) {
    document.documentElement.setAttribute(PULL_TO_REFRESH_LOCK_ATTR, "");
  }
  lockCount += 1;
  return () => {
    if (lockCount <= 0) {
      return;
    }
    lockCount -= 1;
    if (lockCount === 0) {
      document.documentElement.removeAttribute(PULL_TO_REFRESH_LOCK_ATTR);
    }
  };
}

export function isPullToRefreshLocked(): boolean {
  return lockCount > 0;
}

/** Ignora gesto se overlay estiver aberto ou toque começou dentro de sheet/modal. */
export function isPullToRefreshGestureBlocked(
  target: EventTarget | null,
): boolean {
  if (isPullToRefreshLocked()) {
    return true;
  }
  if (!(target instanceof Element)) {
    return false;
  }
  return !!target.closest(PULL_TO_REFRESH_IGNORE_SELECTOR);
}
